import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { PersonalLetter } from './components/PersonalLetter';
import { RealityCheck } from './components/RealityCheck';
import { ImagineScenario } from './components/ImagineScenario';
import { Services } from './components/Services';
import { Testimonials } from './components/Testimonials';
import { EnrollmentPeriods } from './components/EnrollmentPeriods';
import { Faq } from './components/Faq';
import { WhatYouGet } from './components/WhatYouGet';
import { Steps } from './components/Steps';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-cream font-sans text-navy selection:bg-gold selection:text-navy" data-id="element-0">
      <Header data-id="element-1" />

      <main data-id="element-2">
        <div id="inicio" data-id="element-3">
          <Hero data-id="element-4" />
        </div>

        <div className="h-2 w-full bg-gradient-to-r from-navy via-gold to-navy opacity-80" data-id="element-5" />

        <PersonalLetter data-id="element-6" />
        <RealityCheck data-id="element-7" />
        <ImagineScenario data-id="element-8" />

        <div className="flex justify-center py-4 md:py-8 bg-white" data-id="element-9">
          <div className="w-32 h-1 bg-gold rounded-full opacity-30" data-id="element-10" />
        </div>

        <div id="servicios" data-id="element-11">
          <Services data-id="element-12" />
        </div>
        <div id="testimonios" data-id="element-13">
          <Testimonials data-id="element-14" />
        </div>
        <div id="inscripcion" data-id="element-15">
          <EnrollmentPeriods data-id="element-16" />
        </div>

        <div className="h-px w-full bg-gradient-to-r from-transparent via-gold to-transparent opacity-30" data-id="element-17" />

        <div id="faq" data-id="element-18">
          <Faq data-id="element-19" />
        </div>
        <WhatYouGet data-id="element-20" />
        <Steps data-id="element-21" />
        <FinalCta data-id="element-22" />
      </main>

      <Footer data-id="element-23" />
    </div>;
}